module.exports = __webpack_public_path__ + "img/third-plate.4d09e7a7.png";